import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import styled from 'styled-components'

import { theme } from '../../constants/theme'

import { Input } from './Input'

export const Password = (props) => {
  const [passwordVisible, togglePassword] = useState(false)

  return (
    <PasswordWrapper>
      <Input {...props} type={passwordVisible ? 'text' : 'password'} />
      <Control onClick={() => togglePassword(!passwordVisible)} visible={passwordVisible}>
        <FontAwesomeIcon icon={faEye} />
      </Control>
    </PasswordWrapper>
  )
}

const PasswordWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  align-items: center;
`

const Control = styled.div`
  color: ${({ visible }) => (visible ? theme.colors.blue : theme.colors.black)};
  cursor: pointer;
  position: absolute;
  right: 10px;
`
